import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/rentManage',
    meta: { title: '租金管理' },
    component: Layout,
    redirect: '/rentManage/list',
    children: [
      {
        path: 'list',
        meta: { title: '租金管理', activeMenu: '/rentManage' },
        component: () => import('@/views/rentManage/RentManage.vue')
      },
      {
        path: 'detail',
        meta: { title: '租金详情', activeMenu: '/rentManage' },
        component: () => import('@/views/rentManage/RentManageDetail.vue')
      },
      {
        path: 'add',
        meta: { title: '新增租金', activeMenu: '/rentManage' },
        component: () => import('@/views/rentManage/RentManageAdd.vue')
      },
      {
        path: 'edit',
        meta: { title: '编辑租金', activeMenu: '/rentManage' },
        component: () => import('@/views/rentManage/RentManageAdd.vue')
      }

    ]
  }

]
